import React from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import { getWidth } from "../../../utils/relativeSizes";

interface ScoreBalloonProps {
  score: number;
}

const ScoreBalloon: React.FC<ScoreBalloonProps> = ({ score }) => {
  return (
    <div 
      className={clsx(styles.scoreBalloonWrapper)} 
      style={{
        width: getWidth(30),
        height: getWidth(30)
      }}>
      <span className={clsx(styles.scoreBalloonText, "fontSizeSm12 fontWeightBold")}>{`${score >= 0 ? "+" : ""}${score}`}</span>
    </div>
  );
};

export default ScoreBalloon;
